import { render, staticRenderFns } from "./OrderedTable.vue?vue&type=template&id=05b4c0ee"
import script from "./OrderedTable.vue?vue&type=script&lang=js"
export * from "./OrderedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports